import React, { useEffect, useRef } from 'react';
import { CommonHighchartsLine } from '../Ecg/Line/CommonHighchartsLine'


export function DiaryTrendsChart({ selectedParameters, chartData }) {
  const chartRef = useRef(null);
  
  // Configuration for y-axes positioning
  // Highcharts will handle spacing automatically with opposite property
  const getYAxisPosition = (index, total) => {
    if (total === 1) return false; // Single axis on left
    //if (total === 2) return index === 1; // First left, second right
    // For 3+: alternate starting with left
    //return index % 2 === 1;
    return index !== 0;
  };

  const chartOptions = {
    chart: {
      zoomType: 'x'
    },
    title: {
      text: selectedParameters.length > 0 ? 
        selectedParameters.map(p => p.displayName).join(', ') : 
        ''
    },
    xAxis: {
      type: 'datetime',
      maxRange: undefined,
      dateTimeLabelFormats: {
        millisecond: '%d-%m-%Y %H:%M:%S',
        second: '%d-%m-%Y %H:%M:%S',
        minute: '%d-%m-%Y %H:%M',
        hour: '%d-%m-%Y %H:%M',
        day: '%d-%m-%Y',
        week: '%d-%m-%Y',
        month: '%d-%m-%Y',
        year: '%Y'
      }
    },    
    yAxis: [], // Will be populated dynamically
    legend: {
      enabled: selectedParameters.length > 1,
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom'
    },
    plotOptions: {
      series: {
        marker: {
          enabled: true
        }
      }
    }
  };
  
  useEffect(() => {
    if (!chartData || Object.keys(chartData).length === 0) return;
    
    const colors = ['#7cb5ec', '#434348', '#90ed7d', '#f7a35c', '#8085e9', '#f45b5b', '#91e8e1'];
    const parameterUids = Object.keys(chartData);
    const totalParams = parameterUids.length;
    
    // Clear existing series first
    if (chartRef.current && chartRef.current.clearAllSeries) {
      chartRef.current.clearAllSeries();
    }
    
    // Setup y-axes configuration
    const yAxesConfig = [];
    parameterUids.forEach((uid, index) => {
      const parameter = selectedParameters.find(p => p.uid === uid);
      const isOpposite = getYAxisPosition(index, totalParams);
      
      yAxesConfig.push({
        id: `y-axis-${index}`,
        title: {
          text: parameter.displayName,
          style: { color: '#000000' }
        },
        labels: {
          style: { color: '#000000' }
        },
        opposite: isOpposite,
        gridLineWidth: index === 0 ? 1 : 0 // Only show grid for first axis
      });
    });
    
    // Update chart with new y-axes
    if (chartRef.current && chartRef.current.updateYAxes) {
      chartRef.current.updateYAxes(yAxesConfig);
    }
    
    // Add series for each parameter
    parameterUids.forEach((uid, index) => {
      const seriesData = chartData[uid];
      const seriesSettings = {
        seriesId: `series-${uid}`,
        name: seriesData.name,
        type: 'line',
        color: colors[index % colors.length],
        yAxisId: index,
        data: seriesData.data
      };
      
      if (chartRef.current) {
        chartRef.current.setInitialData(seriesData.data, seriesSettings);
      }
    });
  }, [chartData, selectedParameters]);


 

  return (
    <>
      {selectedParameters.length > 0 && (
        <CommonHighchartsLine 
          ref={chartRef} 
          seriesName="" 
          chartOptions={chartOptions}
          multipleSeriesMode={true}
        />      
      )}
    </>
  );
}

